import { getWindow } from '../../../utils/window';

export const jobSectionDomId = 'job-section';
export const topOfCandidateListSectionDomId = 'top-of-candidate-list-section';

const scrollToElement = (
  element: HTMLElement | null,
  threshold = 0,
  animated = false,
) => {
  const win = getWindow();

  if (!win) {
    return;
  }

  const behavior = animated ? 'smooth' : 'auto';
  // only scroll to the top of the list if viewport is below the threshold
  if (win.scrollY > threshold) {
    // if no element - scroll to top
    if (!element) {
      win.scrollTo({ top: threshold, behavior });
      return;
    }
    element.scrollIntoView({ behavior });
  }
};

const scrollToStartOfCandidateList = () => {
  const element = document?.getElementById(topOfCandidateListSectionDomId);
  const header =
    document?.getElementsByTagName('header')[0]?.getBoundingClientRect()
      ?.height || 70;
  const jobSection =
    document?.getElementById(jobSectionDomId)?.getBoundingClientRect()
      ?.height || 128;

  const threshold = header + jobSection;
  scrollToElement(element, threshold, true);
};

export default scrollToStartOfCandidateList;
